import { render, staticRenderFns } from "./hello-bar-detail.vue?vue&type=template&id=4ff265a4&scoped=true&"
import script from "./hello-bar-detail.vue?vue&type=script&lang=js&"
export * from "./hello-bar-detail.vue?vue&type=script&lang=js&"
import style0 from "./hello-bar-detail.vue?vue&type=style&index=0&id=4ff265a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff265a4",
  null
  
)

export default component.exports